// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"f1d6b048","145":"dbca8476","244":"9ed8bf9b","280":"0654040b","373":"8877026e","546":"971e03a6","685":"e5c0f43f","926":"9521d54f","960":"6838509b"}[chunkId] + ".css";
};